import React, { useEffect, useState } from "react";

function Hero({ content }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const heroCells = content?.cells || [];
  const headingLines = content?.headingLines || [];
  const accentLineIndex = content?.accentLineIndex ?? 1;

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setSlideIndex((current) => current + 1);
    }, 5000);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <section className="hero" id="top">
      <div className="hero-left">
        <div className="hero-badge fade-up">
          <span className="hero-badge-dot"></span>
          {content?.badge}
        </div>
        <h1 className="fade-up">
          {headingLines.map((line, index) => (
            <React.Fragment key={`${line}-${index}`}>
              {index === accentLineIndex ? (
                <span className="accent-word">{line}</span>
              ) : (
                line
              )}
              {index < headingLines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </h1>
        <p className="hero-desc fade-up">{content?.description}</p>
        <div className="hero-actions fade-up">
          <a href={`#${content?.primaryCtaTarget || "products"}`} className="btn-primary">
            {content?.primaryCtaLabel}
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
          <a href={`#${content?.secondaryCtaTarget || "contact"}`} className="btn-secondary">
            {content?.secondaryCtaLabel}
          </a>
        </div>
        <div className="hero-stats fade-up">
          {(content?.stats || []).map((stat) => (
            <div key={`${stat.value}-${stat.label}`}>
              <div className="stat-num">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="hero-right">
        <div className="hero-visual-grid">
          {heroCells.map((cell) => {
            const imageSrc = cell.images[slideIndex % cell.images.length];
            const activeDot = slideIndex % cell.images.length;

            return (
              <div className={cell.className} key={cell.title}>
                <div className="hero-vis-media">
                  <img
                    className={`hero-vis-image ${cell.imageClassName}`}
                    src={imageSrc}
                    alt={`${cell.title} product`}
                  />
                </div>
                <div className="hero-vis-overlay" aria-hidden="true"></div>
                <div className={`${cell.labelClass} hero-vis-chip`}>{cell.label}</div>
                <div className="hero-visual-content">
                  <div className="hero-visual-title">{cell.title}</div>
                  <div className="hero-visual-subtitle">{cell.subtitle}</div>
                </div>
                <div className="hero-vis-dots" aria-hidden="true">
                  {cell.images.map((image, index) => (
                    <span
                      className={`hero-vis-dot${index === activeDot ? " is-active" : ""}`}
                      key={image}
                    ></span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Hero;
